<template>
  <div class="calendar-user-modal" v-if="$route.query.userid">
    <button class="calendar-user-modal__close-btn" @click="() => {
        $router.push(`${$route.path}`).then(() => userData = null)
    }"><img src="@/assets/icons/x.svg" alt=""></button>
    {{ getUserData() }}
    <div v-if="userData" class="calendar-user-modal__inner">
      <span>Imię i nazwisko: <b>{{ userData.firstname }} {{ userData.lastname }}</b></span>
      <span>Adres e-mail: <b>{{ userData.email }}</b></span>
      <span>Informacje dodatkowe: <b>{{ userData.calendar_items[0]?.visit_info ?? '' }}</b></span>
      <div class="calendar-user-modal__inner__contact" v-if="!addLinkActive">
        <span>Kontakt</span>
        <textarea name="message" id="message" placeholder="twoja wiadomość" v-model="messageContent"></textarea>
        <button class="cta" @click="() => sendMessage()">wyślij</button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import authHeader from '@/services/auth-header';
import { useAuthStore } from '@/stores/auth';
import { useAppStore } from '@/stores/app';
export default{
  name:'CalendarUserModal',
  setup() {
    return {
      authStore: useAuthStore(),
      appStore: useAppStore(),
    }
  },
  data(){
    return{
      userData: null,
      messageContent: '',
      addLinkActive: false,
      serviceData: {}
    }
  },
  computed: {
    currentUser() {
      return this.authStore.user;
    }
  },
  methods:{
    getUserData(){
      if(!this.userData){
        axios.get(`/user/${this.$route.query.userid}/calendar/${this.$route.params.serviceId}`).then(resp => {
          this.userData = resp.data
        })
      }
      if(!this.serviceData.price && !this.serviceData.name){
        axios.get(`/Service/${this.$route.params.serviceId}`).then(({data: {price, name}}) => {
          this.serviceData.price = price
          this.serviceData.name = name
        }).catch(() => {

        })
      }
    },
    sendMessage(){
      if(this.messageContent.length > 0){
        const ob = {
          title: this.currentUser.data.name,
          content: this.messageContent,
          from_id: this.currentUser.id,
          to_id: this.userData.id
        }
        axios.post('/Message', ob, authHeader())
            .then(res => {
              if(String(res.status).charAt(0) === '2'){
                this.appStore.setIsSuccess( 'Wysłano wiadomość')
              }
            })
      }else{
        this.appStore.setIsAlert( 'wpisz treść wiadomości')
      }
    }
  }
}
</script>

<style scoped lang='scss'>
.calendar-user-modal {
  position: fixed;
  inset: 0;
  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 16px;
  background: rgba(17, 24, 39, 0.45);
  box-sizing: border-box;

  &__inner {
    position: relative;
    width: 100%;
    max-width: 520px;
    max-height: calc(100vh - 32px);
    overflow-y: auto;
    background: #fff;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    box-shadow: 0 12px 30px rgba(17, 24, 39, 0.18);
    padding: 24px;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    gap: 12px;
    color: #1f2937;
    font-family: sans-serif;
    animation: modalFadeIn 0.18s ease-out;

    > span {
      display: flex;
      flex-direction: column;
      gap: 4px;
      padding: 10px 12px;
      border: 1px solid #e5e7eb;
      border-radius: 8px;
      background: #f9fafb;
      color: #6b7280;
      font-size: 1.35rem;
    }

    > span b {
      color: #1f2937;
      font-size: 1.45rem;
      font-weight: 700;
    }

    button.cta {
      border: none;
      border-radius: 8px;
      padding: 10px 14px;
      background: #f2790f;
      color: #fff;
      font-size: 1.4rem;
      font-weight: 600;
      cursor: pointer;
      transition: background-color 0.2s, transform 0.2s;

      &:hover {
        background: #d66a0a;
      }

      &:active {
        transform: translateY(1px);
      }

      &--green {
        background: #10b981;

        &:hover {
          background: #059669;
        }
      }

      &--red {
        background: #bb2d3b;

        &:hover {
          background: #991b1b;
        }
      }
    }

    &__contact,
    &__advance {
      margin-top: 8px;
      padding-top: 16px;
      display: flex;
      flex-direction: column;
      gap: 10px;
      border-top: 1px solid #e5e7eb;

      > span:first-child {
        margin: 0;
        color: #1f2937;
        font-size: 1.8rem;
        font-weight: 700;
      }
    }

    &__contact {
      textarea {
        width: 100%;
        min-height: 120px;
        resize: vertical;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        padding: 10px 12px;
        color: #1f2937;
        font-size: 1.4rem;
        outline: none;
        box-sizing: border-box;
        transition: border-color 0.2s;

        &:focus {
          border-color: #f2790f;
        }
      }

      button.cta {
        align-self: flex-start;
      }
    }

    &__advance {
      label {
        color: #374151;
        font-size: 1.35rem;
        font-weight: 600;
      }

      input {
        width: 100%;
        border: 1px solid #d1d5db;
        border-radius: 8px;
        padding: 10px 12px;
        color: #1f2937;
        font-size: 1.4rem;
        outline: none;
        box-sizing: border-box;
        transition: border-color 0.2s;

        &:focus {
          border-color: #f2790f;
        }
      }

      div {
        display: flex;
        align-items: center;
        gap: 10px;
        flex-wrap: wrap;
        margin-top: 6px;
      }

      div span {
        color: #1f2937;
        background: #f3f4f6;
        border-radius: 999px;
        padding: 8px 12px;
        font-size: 1.4rem;
        font-weight: 700;
      }
    }
  }

  &__close-btn {
    position: absolute;
    top: calc(50% - 250px);
    right: calc(50% - 270px);
    z-index: 101;
    width: 34px;
    height: 34px;
    border: none;
    border-radius: 999px;
    background: #fff;
    cursor: pointer;
    padding: 5px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    box-shadow: 0 2px 8px rgba(17, 24, 39, 0.14);
    transition: background-color 0.2s, transform 0.2s;

    &:hover {
      background: #fff1f2;
      transform: scale(1.04);
    }

    img {
      width: 22px;
      height: 22px;
    }
  }
}

@keyframes modalFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px) scale(0.98);
  }

  to {
    opacity: 1;
    transform: translateY(0) scale(1);
  }
}

@media (max-width: 620px) {
  .calendar-user-modal {
    align-items: flex-start;
    padding: 12px;

    &__inner {
      max-height: calc(100vh - 24px);
      padding: 20px 14px 16px;
      border-radius: 10px;
    }

    &__close-btn {
      top: 20px;
      right: 20px;
    }

    &__inner__contact button.cta,
    &__inner__advance button.cta {
      width: 100%;
    }

    &__inner__advance div {
      align-items: stretch;
      flex-direction: column;
    }

    &__inner__advance div span {
      text-align: center;
    }
  }
}
</style>